export default __webpack_public_path__ + "static/media/Newsletter 012.45873c4f.png";